import Icon from 'veui/components/Icon'
import { IconLocation } from 'dls-icons-vue'

Icon.register('location', IconLocation)
